const SUPPORTED_CHECK_COUNTRIES = [
  {
    name: 'United States of America',
    abbreviation: 'US',
  },
  {
    name: 'Canada',
    abbreviation: 'CA',
  },
  {
    name: 'Puerto Rico',
    abbreviation: 'PR',
  },
];

module.exports = {
  SUPPORTED_CHECK_COUNTRIES,
}
